import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.7041 2.71132C23.0946 2.32079 23.0946 1.68763 22.7041 1.2971C22.3136 0.90658 21.6804 0.90658 21.2899 1.2971L11.9985 10.5885L2.70714 1.2971C2.31661 0.90658 1.68345 0.90658 1.29293 1.2971C0.902401 1.68763 0.902401 2.32079 1.29293 2.71132L10.5843 12.0027L1.29289 21.2941C0.902369 21.6846 0.902369 22.3178 1.29289 22.7083C1.68342 23.0988 2.31658 23.0988 2.70711 22.7083L11.9985 13.4169L21.2899 22.7083C21.6804 23.0988 22.3136 23.0988 22.7041 22.7083C23.0946 22.3178 23.0946 21.6846 22.7041 21.2941L13.4127 12.0027L22.7041 2.71132Z"
  }));
});
var NavigationClose = AbstractIcon.withComponent(Icon);
NavigationClose.displayName = 'NavigationClose';
export default NavigationClose;